import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(hit: any, attribute: string): SafeHtml {
    const result = hit._snippetResult?.[attribute];
    if (!result?.value) return hit[attribute] ?? '';
    return this.sanitizer.bypassSecurityTrustHtml(result.value);
  }
}
